/* eslint-disable no-nested-ternary */
import Box from '@mui/material/Box';
import {
  getEventTemplate,
  resetEventTemplate,
} from '@pingum/app-state-management/eventTemplate/actions';
import PropTypes from 'prop-types';
import React from 'react';
import {
  useDispatch,
  useSelector,
} from 'react-redux';

import { Close } from '@mui/icons-material';
import {
  Dialog,
  DialogContent,
  IconButton,
  Typography,
  useColorScheme,
  useMediaQuery,
} from '@mui/material';
import Page from '../../../components/Page';
import PageBody from '../../../components/PageBody';
import theme from '../../../utils/theme';
import { getQueryParam } from '../../../utils/urlHelper';
import EventTemplateEditor from './components/EventTemplateEditor';

const CalendarEventDetailSettingsPage = ({
  navigate,

  modal,
  openModal,
  passedInModalId,
  onCloseModal,
}) => {
  const dispatch = useDispatch();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  const { mode } = useColorScheme();

  const id = getQueryParam('copy') || passedInModalId || window.location.pathname.replace(/^\/settings\/calendar[/]?/, '').replace(/\/{0,1}\?.*/g, '');

  // Redux state
  const {
    isFetchingEventTemplate,
    eventTemplate: selectedEventTemplate,
  } = useSelector((state) => state.eventTemplate);
  const { isFetchingStatuses } = useSelector((state) => state.status);
  const { isFetchingTag } = useSelector((state) => state.tag);
  const { isFetchingTagTypes } = useSelector((state) => state.tagType);

  const isLoading = isFetchingEventTemplate || isFetchingStatuses || isFetchingTag || isFetchingTagTypes;
  const isCopy = !!getQueryParam('copy');

  React.useEffect(() => {
    if (id && id !== 'new') {
      dispatch(getEventTemplate(id));
    } else {
      dispatch(resetEventTemplate());
    }
  }, []);

  const getEventTemplateEditor = () => (
    <EventTemplateEditor
      navigate={navigate}
      isLoading={isLoading}
      eventTemplate={!id
        ? ({
          name: '',
          description: '',
          eventData: [],
          tags: [],
          allowActiveDuplicates: true,
          eventDataDefaultValues: {},
          workflowStatuses: [],
          configurableTags: true,
          configurableName: true,
          configurableStartStatus: true,
          defaultStartStatus: {
            id: 0,
            name: 'Select A Value...',
            icon: 'search',
            iconColor: 'gray',
          },
        })
        : ((id && isCopy)
          ? {
            ...selectedEventTemplate,
            id: null,
          }
          : selectedEventTemplate)}
      onClose={onCloseModal}
      modal={modal}
    />
  )

  if (modal) {
    const dialogTitle = selectedEventTemplate?.id
      ? 'Edit Calendar Type'
      : 'Create Calendar Type';
    return (
      <Dialog
        open={openModal}
        onClose={onCloseModal}
        fullScreen={fullScreen}
        maxWidth="lg"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 3,
            height: fullScreen
              ? '100%'
              : 'auto',
          },
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            px: 3,
            py: 2,
            borderBottom: '1px solid',
            borderColor: 'divider',
            background: mode === 'light'
              ? 'var(--template-palette-background-default, #fff)'
              : 'var(--template-palette-background-paper)',
          }}
        >
          <Box>
            <Typography variant="h6">{dialogTitle}</Typography>
            <Typography variant="body2" color="text.secondary">
              Configure default details, tasks, and metadata for this calendar event type.
            </Typography>
          </Box>
          <IconButton onClick={onCloseModal}>
            <Close />
          </IconButton>
        </Box>
        <DialogContent
          sx={{
            p: {
              xs: 2,
              md: 3,
            },
          }}
        >
          {getEventTemplateEditor()}
        </DialogContent>
      </Dialog>
    );
  }

  if (!id) {
    return (
      <Page>
        <Box sx={{ width: '100%' }}>
          <PageBody navigate={navigate}>
            {getEventTemplateEditor()}
          </PageBody>
        </Box>
      </Page>
    );
  }

  return (
    <Page>
      <Box sx={{ width: '100%' }}>
        <PageBody>
          {getEventTemplateEditor()}
        </PageBody>
      </Box>
    </Page>
  );
};

CalendarEventDetailSettingsPage.propTypes = {
  navigate: PropTypes.func.isRequired,
  modal: PropTypes.bool,
  openModal: PropTypes.bool,
  passedInModalId: PropTypes.any,
  onCloseModal: PropTypes.func,

};

CalendarEventDetailSettingsPage.defaultProps = {
  modal: false,
  openModal: false,
  passedInModalId: null,
  onCloseModal: () => { },
};

export default CalendarEventDetailSettingsPage;
